<template >
  <boxDropDown title="Destravar escala">
    <template class="support-tools">

      <div class="form-group col-md-6">
        <label for="companyId">ID da empresa</label>
        <input type="companyId" class="form-control" placeholder="ID da empresa" id="companyId" name="companyIdName" v-model="dataSend.companyId">
      </div>

      <div class="form-group col-md-6">
        <label for="scaleId">ID da escala</label>
        <input type="text" class="form-control" v-model="dataSend.scaleId" placeholder="ID da escala" id="scaleId" name="scaleIdName">
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" @click="sendData()">
          <span v-if="!loadingUnlockScale">Destravar escala</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateFields }}</span>
      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import datepicker from "vuejs-datepicker";
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import {
    ENQUEUE_WORK_SCHEDULE, CONTEXT_COMPANY
  } from "../../../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";

  export default {
    name: "unlock-scale",
    components: {
      boxDropDown,
      datepicker,
    },
    data() {
      return {
        messageValidateFields: "",
        dataSend: {
          companyId: "",
          scaleId: ""
        },
        loadingUnlockScale: false,
        contentSetting: ""
      }
    },
    methods: {
      validateFields() {
        if (this.dataSend.companyId.length !== 32) {
          this.messageValidateFields = "Id da empresa é inválido";
          return false;
        }

        if (this.dataSend.scaleId.length !== 36) {
          this.messageValidateFields = "Id da escala é inválido";
          return false;
        }

        this.messageValidateFields = "";
        return true;
      },
      sendData() {
        if (!this.validateFields()) {
          return;
        }

        let bodyRequest = {
          companyId: this.dataSend.companyId,
          workScheduleId: this.dataSend.scaleId
        };

        this.loadingUnlockScale = true;

        REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.dataSend.companyId}`).then((response) => {
          this.contentSetting = response.data;
          let bodyRequestJSON = JSON.stringify(bodyRequest);

          REQUEST_SERVICE.requestContext('PUT', ENQUEUE_WORK_SCHEDULE, this.contentSetting, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Escala enfileirada para ser destravada com sucesso!", "success");
            this.clearFields();
            this.loadingUnlockScale = false;
          }).catch((reason) => {
            this.loadingUnlockScale = false;
            if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
          });
        }).catch((reason) => {
          this.loadingUnlockScale = false;
          ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
        });
        
      },
      clearFields(){
        this.dataSend.companyId = "";
        this.dataSend.scaleId = "";
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }

  .company-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F0F0F0;
    padding: 10px 10px 10px 20px;
    margin-bottom: 15px;

    &__title {
      font-weight: bold;
      color: #201E1E;
    }

    &__close {
      height: 16px;
      width: 16px;
      font-size: 16px;
      color: #E74A4E;
      cursor: pointer;
    }
  }

  .center{
    margin: auto;
  }

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/unlockScale.vue